const configAlarm = {
    alarm: {
        listLayout: 'AlarmListDefaultLayout',
        emptyLayout: 'AlarmEmptyDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getAlarm',
        listApiParamSet: {
            paging: true,
        },
        paginationType: 'pagination',
    },
};

export default {
    methods: {
        returnAlarmConfig(type) {
            return configAlarm[type];
        },

    },
    filterConfig: {}
}
